const SCRIPT_UNSAFE = new RegExp('[<>&\\u2028\\u2029]', 'g');

function toUnicodeEscape(char: string): string {
  return '\\u' + char.charCodeAt(0).toString(16).padStart(4, '0');
}

/**
 * Serializes a value to JSON for safe inlining inside a `<script>` tag.
 *
 * @remarks
 * `JSON.stringify` alone is unsafe to drop into a `<script>`: a `<` lets a value
 * close the tag early (`</script>`), and the U+2028 / U+2029 line terminators are
 * valid in JSON but illegal in JS source, breaking the inline script. This escapes
 * `<`, `>`, `&`, U+2028, and U+2029 to their `\uXXXX` forms (matching what
 * `serialize-javascript` does), leaving the parsed value unchanged.
 *
 * @param value any JSON-serializable value
 * @returns the escaped JSON string
 */
export function serializeForScript(value: unknown): string {
  return JSON.stringify(value).replace(SCRIPT_UNSAFE, toUnicodeEscape);
}
